import { report } from '@/apis'
import { jin10Behavior } from '@/commons/utils'
import { mapState, mapGetters } from 'vuex'

export default {
  ...mapState(['pageType', 'topNavs']),
  ...mapGetters([
    'liveInfo'
  ]),
  data () {
    return {
      hasReported: false,
      currentMinute: 0,
      onlineTimer: null,
      postLiveName: ''
    }
  },
  watch: {
    currentMinute (minute) {
      if (minute <= 5) {
        this.postStatics(minute)
      } else if (minute % 5 === 0) {
        this.postStatics(minute)
      }
    },
    $route (to, from) {
      this.stopLiveVideoTimer()
    }
  },
  methods: {
    report () {
      const { roomID = -999 } = this.liveInfo
      const live = this.topNavs.find(it => parseInt(it.room_id) === parseInt(roomID))
      if (live && live.name) {
        this.postLiveName = live.name
      }
      if (this.postLiveName) {
        this.startLiveVideoTimer()
      } else {
        this.stopLiveVideoTimer()
      }
      if (this.hasReported) {
        return false
      }

      this.hasReported = true

      let channel = 'WEB_PC'

      if (this.jsBridge.isApp) {
        channel = 'APP_H5' + (this.jsBridge.isIOSApp ? '_IOS' : '_ANDROID')
      } else if (this.isMobile) {
        channel = 'WEB_H5'
      }

      report({
        live_id: this.videoID,
        channel
      })
    },
    startLiveVideoTimer () {
      this.onlineTimer = setInterval(() => {
        this.currentMinute = this.currentMinute + 1
      }, 60000)
    },
    stopLiveVideoTimer () {
      if (this.onlineTimer) {
        clearInterval(this.onlineTimer)
        this.onlineTimer = null
      }
      this.currentMinute = 0
    },
    postStatics (minute) {
      console.log('postStatics', minute)
      jin10Behavior({
        pageName: 'tv直播页',
        module: '直播',
        action: '点击',
        type: '停留时长',
        params: {
          program: this.postLiveName,
          status: this.isPlayingRepeat ? '回放' : '直播中',
          online_time: minute
        }
      })
    }
  },
  beforeDestroy () {
    this.stopLiveVideoTimer()
  }
}



// WEBPACK FOOTER //
// ./src/views/tv/modules/Content/src/video.mixin.js